import React from 'react';

import { SelectInput, Spinner} from '@sogei/react-web-components-catalog'
import { observer, inject } from "mobx-react";
import i18next from 'i18next';




@inject("rootStore")
@observer
class SelectAnni extends React.Component {

  constructor(props) {
    super(props);
    this.ricevuteStore = props.rootStore.ricevuteStore;
  
  }

  componentDidMount() {
    if(this.props.tipoPratica == 'CI'  && this.props.isFromElenchi){
      this.ricevuteStore.fetchListaAnni();
    }
    
  }

 

  render() {
   
    const sAnni = (props) => {
    const listaAnni = this.ricevuteStore.listaAnni;
      this.values = props.values;
      //console.log("this.values: ", JSON.stringify(this.values));
    

      //console.log("props: ", JSON.stringify(props));
     
      return (
        
        props.tipoPratica == 'CI'  && props.isFromElenchi?
        listaAnni.length===0?
        
           <Spinner isLoading={true}/>
        
          :

          <div className='row'>
            <div className='col-sm-12 col-md-6 col-xl-4'>
            <SelectInput
                        id="anno"
                        name="anno"
                        value={this.values.anno}
                        dimension="lg"
                        label={i18next.t("ANNO")}
                        firstEmptyOption={true}
                        optionList={listaAnni}
                      
                        inputClass={[]}
                        labelClass={[]}
                        event={{
                        onChange:  props.onChange
                        }}
                        error={props.touched.anno && props.errors.anno}
                        extraProps={{
                        
                        }}
                    />
            </div>
        </div>
        
        :null
      )

    }
    
    return (
        sAnni(this.props)

    );
  }

}




//export default SceltaTipoInvio;

export {SelectAnni}; 